"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var eventstream_marshaller_1 = require("@aws-sdk/eventstream-marshaller");

var utils_1 = require("./utils");

var getChunkedStream_1 = require("./getChunkedStream");

var getEventMessageStream_1 = require("./getEventMessageStream");

var getDeserializingStream_1 = require("./getDeserializingStream");

var EventStreamMarshaller =
/** @class */
function () {
  function EventStreamMarshaller(_a) {
    var utf8Encoder = _a.utf8Encoder,
        utf8Decoder = _a.utf8Decoder;
    this.eventMarshaller = new eventstream_marshaller_1.EventStreamMarshaller(utf8Encoder, utf8Decoder);
  }

  EventStreamMarshaller.prototype.deserialize = function (body, deserializer) {
    var chunkedStream = getChunkedStream_1.getChunkedStream(body);
    var messageStream = getEventMessageStream_1.getEventMessageStream(chunkedStream, this.eventMarshaller);
    var deserialingStream = getDeserializingStream_1.getDeserializingStream(messageStream, deserializer);
    return utils_1.ReadableStreamtoIterable(deserialingStream);
  };
  /**
   * Generate a ReadableStream that serialize events
   * to event stream binary chunks; Use a pull stream
   * here to support low connection speed.
   *
   * This doesn't work on browser currently because
   * browser doesn't support upload streaming.
   * reference:
   * * https://bugs.chromium.org/p/chromium/issues/detail?id=688906
   * * https://bugzilla.mozilla.org/show_bug.cgi?id=1387483
   *
   */


  EventStreamMarshaller.prototype.serialize = function (input, serializer) {
    throw new Error("event stream request in browser is not supported\nReference: https://bugs.chromium.org/p/chromium/issues/detail?id=688906");
  };

  return EventStreamMarshaller;
}();

exports.EventStreamMarshaller = EventStreamMarshaller;